// -didim_realty_world
import React, { Suspense, useEffect } from "react";
import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import { Outlet, useLocation } from "react-router-dom";
import usePageData from "@/api/hooks/usePageData";
import PageLoader from "@/components/PageLoader";

const Layout = () => {
    const location = useLocation();

    // Layout verilerini çek
    const { data: layoutData, isLoading } = usePageData({
        myCustomPath: "/layout"
    });

    useEffect(() => {
        document.scrollingElement?.scrollTo(0, 0);
    }, [location.pathname]);

    useEffect(() => {
        if (layoutData) {
            console.log(layoutData);
        }
    }, [layoutData]);

    // Show loader while layout data is loading
    if (isLoading) {
        return <PageLoader />;
    }

    return (
        <div className="flex flex-col min-h-screen">
            <Header layoutData={layoutData} />
            <main className="flex-1">
                <Suspense fallback={<PageLoader />}>
                    <Outlet />
                </Suspense>
            </main>
            <Footer layoutData={layoutData} />
        </div>
    )
}

export default Layout;